<script setup lang="ts">
const terminalColumnCount = 80
const asciiArtSource = String.raw`
                                    undetect.io

                .................      ..       .       .
          .......---.----------.    .-#-.--.   ....    ...     ...
   ..     --....-.-..  .-------.  .-##.    .+.     .   .-.....-----.......
..-----------------.--. -----....-###-       .-..----.-------------------------.
 .---------------....-  .--   ..#+##+.         +..-----------------------------.
 ....  .---------...---.     .-+###-.           ------------------------. .-.
         .----------+-...    -#####.             -----+------------+-++--.
         .-----------..     .##+##.--.          ..+..------------------...
          ----------        ++-####. .          ..-------------------..-.
           .----...        .+.####--+.-+-.       .-#.----------------.
            ..-......     .-..-##+.     ..-.      .#-----..---.---....
                .-....    .- -#-    ..--..  +...   .+-...  .-   --. ..
                  .-----. -.-+.  ..-+####++-. .+-  .---.       ....-..
                 .-------.+-.  .     ..+-.     ..-. --          .-.-...--...
                  .------+-.  .-+....-+-++....--. --.+.           ......... ..
                   .-----#     .##+###- .###+##-   .--+-.           .-----.
                   .---.-.         .+#.-.+#-.       ..-.           ---------
                   --. .-.         .+######-        ...-           .--..---.  ..
                  .-..--.-.         .--+++-.       .....--              ...  ...
                   .+-.   ..                       ...   .-+.                 .
                .--.                                        .--.
                .


`.trimEnd()

const asciiArt = asciiArtSource
  .split("\n")
  .map((line) => line.padEnd(terminalColumnCount, " "))
  .join("\n")
</script>

<template>
  <pre class="dashboard-auth-cli-line dashboard-auth-cli-graphic">{{ asciiArt }}</pre>
</template>
